import flatpickr from 'flatpickr' // flatpickr
import 'flatpickr/dist/l10n/ja' // flatpickr日本語化

/*
flatpickrによるデートピッカー
※preset/_js.scssのCSSインポートを有効化して使用する

<input type="text" name="date1" class="js-date">
<input type="text" name="date2" class="js-date">
*/

window.setCalender = function () {
  plain()

  function plain() {
    if (!document.querySelector('[type="date"]:not(.flatpickr-input)')) {
      return
    }

    // ブラウザバック時に入力値を戻すためにpageshowで動作させる
    const datepicker = flatpickr('[type="date"]:not(.flatpickr-input)', {
      // 指定クラスにデートピッカーを付ける
      // minDate: new Date().fp_incr(1), // 最短設定日 n日後から
      // maxDate: new Date().fp_incr(30), // 最長設定日 n日後まで
      // mode: 'range', // 範囲で指定させる
      locale: 'ja',
      altFormat: 'Y/m/d',
      dateFormat: 'Y/m/d',
      disableMobile: true, // SP時にブラウザ標準の日付UIに切り替えない
      // altFormat: 'Y/m/d H:i',
      // dateFormat: 'Y/m/d H:i',
      // enableTime: true, // 時間指定可能にする
      // time_24hr: false, // 24h/AMPM形式
      disable: [
        // 選択禁止する日付　trueを返すと禁止
        // function (date) {
        //   // 指定番号の曜日と合致したら禁止　0:日曜～6:土曜
        //   if (date.getDay() === 0) {
        //     return true
        //   }
        // },
      ],
      onChange: function (selectedDates, dateStr, instance) {},
    })

    // 日付セット処理が実行されたらカレンダーと整合性を取る
    window.addEventListener('click', function (e) {
      const item = e.target.closest('.js-publishDate-set')
      if (!item) {
        return
      }

      if (Array.isArray(datepicker)) {
        for (const element of datepicker) {
          element.setDate(element.input.value)
        }
      } else {
        datepicker.setDate(element.input.value)
      }
    })

    // デフォルトのflatpickrにはクリアボタンが無いのでカレンダー内に増設する
    const datepickerList = document.querySelectorAll('.flatpickr-calendar:not(.js-calSetClear)')
    for (let index = 0; index < datepickerList.length; index++) {
      const element = datepickerList[index]
      element.classList.add('js-calSetClear')
      const datepickerBtn = document.createElement('button')
      datepickerBtn.innerHTML = '×クリア' // 文言
      datepickerBtn.setAttribute('type', 'button')
      datepickerBtn.setAttribute('style', 'padding: 5px;color: #F67A79')
      datepickerBtn.setAttribute('data-datepicker-clear', index)
      datepickerBtn.addEventListener('click', function (e) {
        if (Array.isArray(datepicker)) {
          datepicker[this.dataset.datepickerClear].clear() // クリア処理
          datepicker[this.dataset.datepickerClear].close() // カレンダーを閉じる
        } else {
          datepicker.clear() // クリア処理
          datepicker.close() // カレンダーを閉じる
        }
      })
      element.appendChild(datepickerBtn)
    }
  }

  btn()

  function btn() {
    if (!document.querySelector('.js-btnDate:not(.flatpickr-input)')) {
      return
    }

    // ブラウザバック時に入力値を戻すためにpageshowで動作させる
    const calList = document.querySelectorAll('.js-btnDate:not(.flatpickr-input)')

    for (const element of calList) {
      // 不正な文字列が入っているとカレンダーが展開できないのでテキストを一時保管する
      const saveText = element.value

      element.value = ''

      const datepicker = flatpickr(element, {
        allowInput: true, // 手入力も許可
        clickOpens: false, // 入力欄クリックでは開かない
        locale: 'ja',
        altFormat: 'Y/m/d',
        dateFormat: 'Y/m/d',
        disableMobile: true,
        allowInvalidPreload: true,
        parseDate: (datestr, format) => undefined,
      })

      // テキストを復元する
      element.value = saveText

      const btnDOM = document.createElement('button')
      btnDOM.innerText = '　'
      btnDOM.setAttribute('type', 'button')
      btnDOM.setAttribute('class', 'calenderBtn flex vcenter hcenter')
      btnDOM.addEventListener('click', function (e) {
        datepicker.toggle()
      })
      btnDOM.innerHTML = '<i class="icon-cal is-false"></i>'

      element.parentNode.insertBefore(btnDOM, element.nextSibling) // 要素の直後に追加

      // デフォルトのflatpickrにはクリアボタンが無いのでカレンダー内に増設する
      const datepickerList = document.querySelectorAll('.flatpickr-calendar:not(.js-calSetClear)')
      for (let index = 0; index < datepickerList.length; index++) {
        const element = datepickerList[index]
        element.classList.add('js-calSetClear')
        const datepickerBtn = document.createElement('button')
        datepickerBtn.innerHTML = '×クリア' // 文言
        datepickerBtn.setAttribute('type', 'button')
        datepickerBtn.setAttribute('style', 'padding: 5px;color: #F67A79')
        datepickerBtn.setAttribute('data-datepicker-clear', index)
        datepickerBtn.addEventListener('click', function (e) {
          if (Array.isArray(datepicker)) {
            datepicker[this.dataset.datepickerClear].clear() // クリア処理
            datepicker[this.dataset.datepickerClear].close() // カレンダーを閉じる
          } else {
            datepicker.clear() // クリア処理
            datepicker.close() // カレンダーを閉じる
          }
        })
        element.appendChild(datepickerBtn)
      }
    }
  }
}

window.setCalender() // カレンダーを設定
